import {
  deliverySettingsVersionSchema,
  etaSettingsVersionSchema,
  multiorderParamsVersionSchema,
  type DeliverySettingsFormValues,
  type EtaSettingsFormValues,
  type MultiorderParamsFormValues,
} from '../model/schema';
import { createVersionedSettingsApi } from './versioned-settings-api';

/** `created_by` is stamped client-side from the signed-in admin when known. */
interface Authored {
  created_by?: string;
}

export const deliverySettingsApi = createVersionedSettingsApi<
  typeof deliverySettingsVersionSchema,
  DeliverySettingsFormValues & Authored
>('/api/v1/admin/delivery-settings', deliverySettingsVersionSchema);

export const etaSettingsApi = createVersionedSettingsApi<
  typeof etaSettingsVersionSchema,
  EtaSettingsFormValues & Authored
>('/api/v1/admin/eta-settings', etaSettingsVersionSchema);

export const multiorderParamsApi = createVersionedSettingsApi<
  typeof multiorderParamsVersionSchema,
  MultiorderParamsFormValues & Authored
>('/api/v1/admin/multiorder-params', multiorderParamsVersionSchema);
